
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.333 6.667a.667.667 0 00-.666.667v6c0 .368.298.667.666.667h6a.667.667 0 00.667-.667v-6a.667.667 0 00-.667-.667h-6zm-2 .667a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2v-6z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.667 2A.667.667 0 002 2.665v6a.667.667 0 00.667.667h.666a.667.667 0 010 1.333h-.666a2 2 0 01-2-2v-6a2 2 0 012-2h6a2 2 0 012 2v.667a.667.667 0 01-1.334 0v-.667a.667.667 0 00-.666-.667h-6z"}})])
          )
        }
      }
    